import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'

import MeetingLinksStatistic from '../components/MeetingLinksStatistic'
import { getMeetingLinkStatistics, selectMeetingLinkStatistics } from '@/redux/reducers/statistic.reducer'

export default function MeetingLinksStatisticContainer() {
  const dispatch = useAppDispatch()

  const { pendingBulkOrders, pendingOrders, totalMeetingLinks, totalOrders } = useAppSelector(selectMeetingLinkStatistics)

  useEffect(() => {
    dispatch(getMeetingLinkStatistics())
  }, [dispatch])

  return (
    <MeetingLinksStatistic
      meetingLinksCount={totalMeetingLinks}
      pendingBulkOrderCount={pendingBulkOrders}
      pendingOrderCount={pendingOrders}
      ordersCount={totalOrders}
    />
  )
}
